module.exports = __webpack_public_path__ + "a11e48a6ac372b1496abac3e1f5f8278.svg";